import React, { useState, Fragment, useEffect } from "react"
import ColorPickerForm from "./ColorPickerForm"
import ColorPickerList from "./ColorPickerList"

import { useDispatch, useSelector } from "react-redux"

const ColorPicker = () => {
	const [lista, setLista] = useState([])
	const [id, setId] = useState(0)
	const [color, setColor] = useState("")
	const [nombre, setNombre] = useState("")
	const [verColorPicker, setVerColorPicker] = useState(false)
	const [tag, setTag] = useState()

	const tagsApi = useSelector((state) => state.tags.custom_tags)
	const selectedBaseId = useSelector((state) => state.multiBase.selectedBase.project_id)

	useEffect(() => {
		setNombre("")
		setColor("")
		setId("")
	}, [selectedBaseId])

	return (
		<Fragment>
			<div className="col-row">
				<ColorPickerForm
					color={color}
					setColor={setColor}
					nombre={nombre}
					setNombre={setNombre}
					verColorPicker={verColorPicker}
					setVerColorPicker={setVerColorPicker}
					lista={lista}
					setLista={setLista}
					id={id}
					setId={setId}
					setTag={setTag}
				/>
			</div>
			<div className="col-row">
				<ColorPickerList />
			</div>
		</Fragment>
	)
}

export default ColorPicker
